import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const tlstore = new Vuex.Store({
  // 内存数据状态，UI可通过this.$store.state.* 获得数据
  state:{
  	user:{},
  	secret:'42da89aa6aba35db60bb5a4850f095c2',
    hasLogin:false
  },
  mutations:{
  	init(state,user){
  		state.user=user;
      state.hasLogin=true;
  	},
    canLogin(state,flag){
      alert(1)
      state.hasLogin=true
    }
  }
})

export default tlstore


// WEBPACK FOOTER //
// ./src/store/tlconfig.js